<template>
  <Modal
    :visible="showRef"
    :max-width="65"
    :style-class="classModal"
    :style-class-contain="styleClassContain"
    :class-name="'edit-modal-action !tw-translate-y-[0]'"
    @close="onCloseModal"
  >
    <ModalHeader
      :class="`modal-header`"
      :title="
        getComponentUiText(
          'app-assess-recommendations-section-action-create-action-option-1',
        )
      "
      @close="handleCloseModal"
    />
    <div class="tw-overflow-auto hiddenBorderFirstChild">
      <div class="tw-px-[20px] sm:tw-px-[40px]">
        <TableActionSwitchTab
          :tabs="tabs"
          :default-tab="0"
          :id-selected-tab="activeTab"
          item-class="tw-px-[25px] tw-pt-[24px] tw-pb-[21px] !tw-text-[16px]"
          @update:tab="activeTab = $event"
        >
          <template #rightHeader><div></div></template>
        </TableActionSwitchTab>
      </div>
      <component
        :is="tabs.filter((item) => item?.id === activeTab)[0].component"
        :data="{}"
        v-bind="tabs.filter((item) => item?.id === activeTab)[0].props"
        @update:show="handleCloseModal"
        @update:use="handleUseAction"
      />
    </div>
  </Modal>
</template>

<script setup lang="ts">
import ModalHeader from "@/components/common/modalHeader.vue";
import { getComponentUiText } from "@/utils/utilities";
import { computed, ref, watch } from "vue";
import Modal from "@/components/common/modal.vue";
import TableActionSwitchTab from "./tableActionSwitchTab.vue";
import { ISwitchTabs } from "@/interfaces/assessments/ISwitchTabs";
import {
  classModal,
  idTabActionTableRecommendation,
  styleClassContain,
} from "@/utils/constants";
import CreateActionNewTab from "./createActionNewTab.vue";
import AddNewActionSuggestedTab from "./addNewActionSuggestedTab.vue";
import eventEmitter, { EmitterEvents } from "@/utils/eventEmitter";

const activeTab = ref(idTabActionTableRecommendation.overview);

const dataAction = ref({});

// add tab component to field component
const tabs = computed<ISwitchTabs[]>(() => {
  return [
    {
      title: getComponentUiText(
        "app-assess-recommendations-section-action-create-action-title-new-1",
      ),
      id: idTabActionTableRecommendation.overview,
      component: CreateActionNewTab,
      props: {
        data: dataAction.value,
        show: showRef,
      },
    },
    {
      title: getComponentUiText(
        "app-component-suggestion-button-title-suggested-1",
      ),
      id: idTabActionTableRecommendation.stepsToSolve,
      component: AddNewActionSuggestedTab,
    },
  ];
});

const props = defineProps({
  show: {
    type: Boolean,
    required: true,
  },
});

const showRef = ref(props.show);
const isDirty = ref(false);

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
  },
);

const emit = defineEmits(["update:show", "update:data"]);

const handleUseAction = (data: any) => {
  activeTab.value = idTabActionTableRecommendation.overview;
  dataAction.value = data?.addedActions[0];
};

const onCloseModal = () => {
  if (isDirty.value) {
    return;
  }
  handleCloseModal();
};
const handleCloseModal = () => {
  eventEmitter.emit(EmitterEvents.REMOVE_ITEM_SELECTED_ROW, []);
  showRef.value = false;
  emit("update:show", showRef.value);
};
</script>

<style lang="scss" scoped>
.assessment-modal {
  .button-verify.btn.btn-primary[disabled] {
    // background-color: #dbdbdb;
    background-color: red;
    color: #b7b7b7;
    border-color: #dbdbdb;
  }

  .button-verify {
    line-height: 100%;
    background-color: #387dff;
    border-color: #387dff;
  }
}

@media (max-width: 768px) {
  .assessment-modal {
    .modal-assessment,
    .modal-header {
      padding-right: 10px;
      padding-left: 10px;
    }
  }
}
.hiddenBorderFirstChild > div:first-of-type {
  border: none !important;
}

.edit-modal-action {
  max-height: calc(100vh - 150px) !important;
  top: 103px !important; // 115px + 56px
}
</style>
